import { useCallback } from 'react'
import { fireGTMEvent } from '../utils/fireGTMEvent'
import useAppSelector from './useAppSelector'
import getAnalyticsItems from '../utils/getAnalyticsItems'

/**
 * React hook to fire Google Tag Manager (GTM) events.
 * @returns {Function} fireEvent - Function to fire a GTM event with the specified name and data.
 */
const useFireGTMEvent = () => {
  const cartState = useAppSelector((state) => state.cartSlice)
  const currency = useAppSelector(
    (state) => state.defaultSlice.config?.options?.currencyPrefix || '',
  )

  const fireViewCartEvent = useCallback(() => {
    const items = getAnalyticsItems(cartState)
    fireGTMEvent('commerce-view_cart', {
      currency,
      value: cartState.total,
      items,
    })
  }, [cartState, currency])

  return fireViewCartEvent
}

export default useFireGTMEvent
